import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../../../components/SearchForm/components/ViewSwitch/components/Tab/components/Container.js';
import { Content } from '../../../../../../components/SearchForm/components/ViewSwitch/components/Tab/components/Content.js';
export const Tab = /*#__PURE__*/_styled(({
  children,
  active,
  'data-label': dataLabel,
  ...restProps
}) => {
  return _jsx(Container, {
    active: active,
    ...restProps,
    children: _jsx(Content, {
      "data-label": dataLabel,
      children: children
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e18seyuo0"
} : {
  target: "e18seyuo0",
  label: "Tab"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1HIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uLy4uLy4uLy4uLy4uL2NvbXBvbmVudHMvU2VhcmNoRm9ybS9jb21wb25lbnRzL1ZpZXdTd2l0Y2gvY29tcG9uZW50cy9UYWIvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgQ29udGVudCB9IGZyb20gJy4uLy4uLy4uLy4uLy4uLy4uL2NvbXBvbmVudHMvU2VhcmNoRm9ybS9jb21wb25lbnRzL1ZpZXdTd2l0Y2gvY29tcG9uZW50cy9UYWIvY29tcG9uZW50cy9Db250ZW50LmpzJztcbmV4cG9ydCBjb25zdCBUYWIgPSBzdHlsZWQoKHsgY2hpbGRyZW4sIGFjdGl2ZSwgJ2RhdGEtbGFiZWwnOiBkYXRhTGFiZWwsIC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgcmV0dXJuIChfanN4KENvbnRhaW5lciwgeyBhY3RpdmU6IGFjdGl2ZSwgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogX2pzeChDb250ZW50LCB7IFwiZGF0YS1sYWJlbFwiOiBkYXRhTGFiZWwsIGNoaWxkcmVuOiBjaGlsZHJlbiB9KSB9KSk7XG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPWluZGV4LmpzLm1hcCJdfQ== */");